import classNames from 'classnames';
import React, { ReactNode } from 'react';
interface Props {
  children: ReactNode;
  className?: string;
  hasBorder?: boolean;
}
const MiniComponentContainer: React.FC<Props> = ({
  children,
  className,
  hasBorder = true,
}) => {
  return (
    <div
      className={classNames(
        'z-0 flex items-center gap-1 rounded-lg border-grey-200 bg-background-transparent py-6 px-2',
        className,
        hasBorder && 'border-xs'
      )}
    >
      {children}
    </div>
  );
};

export default MiniComponentContainer;
